export default __webpack_public_path__ + "locales/az/DownloadDialog.json?hash=83e7186cbee46a8dbb9126a43802fc8b";